/**
 * Word audio assets — PWA port of client-native/assets/audio/words/index.ts.
 *
 * Native-speaker recordings for Spanish words used in Flight School
 * (generated with ElevenLabs TTS). The mp3 files are bundled by Vite via
 * import.meta.glob; the alias map below mirrors the iOS index exactly
 * (accented word ids map to their unaccented file names).
 */

const files = import.meta.glob<string>("./*.mp3", {
  eager: true,
  query: "?url",
  import: "default",
});

function url(name: string): string | undefined {
  return files[`./${name}.mp3`];
}

function removeDiacritics(text: string): string {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

// Ids whose file name differs from removeDiacritics(id) — mirrors the explicit
// entries in the iOS index ("me" is recorded as me-spanish.mp3).
const SPECIAL_FILES: Record<string, string> = {
  me: "me-spanish",
};

/** Get the playable URL for a word id, or undefined if no recording exists. */
export function getWordAudio(wordId: string): string | undefined {
  const special = SPECIAL_FILES[wordId];
  if (special) return url(special);
  return url(wordId) ?? url(removeDiacritics(wordId));
}

/** Check whether a recording exists for a word id. */
export function hasWordAudio(wordId: string): boolean {
  return getWordAudio(wordId) !== undefined;
}
